import React from 'react'

import { ANGLE_MAP } from '@ui/icons/utils/icon-direction'
import { withDirectionalStatics } from '@ui/icons/utils/withDirectionalStatics'

export const ArrowCircleIcon = withDirectionalStatics((props) => {
  const { size, color, direction = 'up' } = props
  const rotation = ANGLE_MAP[direction] ?? 0

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <g transform={`rotate(${rotation} 12 12)`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12.75 9.81066L14.4697 11.5303C14.7626 11.8232 15.2374 11.8232 15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697L13.2374 8.17678C12.554 7.49336 11.446 7.49336 10.7626 8.17678L8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303C8.76256 11.8232 9.23744 11.8232 9.53033 11.5303L11.25 9.81066V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V9.81066Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
